import React from 'react'

export const fieldInput =
  'w-full min-w-0 rounded-lg bg-surface-2 px-2 py-1 text-sm text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-400'

export const EditButtons = ({ onSave, onCancel, saveDisabled, updateLoading }) => (
  <span className="inline-flex items-center gap-1">
    <button
      type="button"
      onClick={onSave}
      disabled={updateLoading || saveDisabled}
      className="inline-flex items-center rounded p-0.5 text-brand-100 transition hover:text-white disabled:opacity-50"
    >
      <span className="material-icons text-sm">check</span>
    </button>
    <button
      type="button"
      onClick={onCancel}
      disabled={updateLoading}
      className="inline-flex items-center rounded p-0.5 text-muted-400 transition hover:text-white disabled:opacity-50"
    >
      <span className="material-icons text-sm">close</span>
    </button>
  </span>
)

export const MetaField = ({
  label,
  children,
  editing,
  editor,
  onStartEdit,
  canEdit,
  editTitle,
  mono = false,
  truncate = false,
}) => (
  <div className="group flex min-w-0 items-center gap-2">
    <span className="w-36 shrink-0 text-xs text-muted-500">{label}</span>
    {editing ? (
      <div className="flex min-w-0 flex-1 items-center gap-2">{editor}</div>
    ) : (
      <>
        <div
          className={`min-w-0 text-sm text-white ${mono ? 'font-mono tabular-nums' : ''} ${
            truncate ? 'max-w-xs truncate' : 'truncate'
          }`}
        >
          {children}
        </div>
        {canEdit && (
          <button
            type="button"
            onClick={onStartEdit}
            className="inline-flex shrink-0 items-center rounded p-0.5 text-muted-500 opacity-0 transition group-hover:opacity-100 hover:text-white focus:opacity-100"
            title={editTitle}
          >
            <span className="material-icons text-sm">edit</span>
          </button>
        )}
      </>
    )}
  </div>
)
